<template>
  <div
    v-if="content"
    ref="textFormatterRef"
    class="text-formatter"
    v-html="content">
    <div v-if="hasIframe" class="cookieconsent-optout-marketing">
      {{ tStatic('hiddenContentText') }}
      <a href="javascript:Cookiebot.renew()">{{ tStatic('updateConsentText') }}</a>
    </div>
  </div>
  <div v-else ref="textFormatterRef" class="text-formatter">
    <div v-if="hasIframe" class="cookieconsent-optout-marketing">
      {{ tStatic('hiddenContentText') }}
      <a href="javascript:Cookiebot.renew()">{{ tStatic('updateConsentText') }}</a>
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { onMounted, defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  props: {
    content: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup() {
    const hasIframe = ref(false)
    const textFormatterRef = ref(null)

    onMounted(() => {
      const el = textFormatterRef.value
      if (el && el.querySelector('iframe')) {
        hasIframe.value = true
      }
    })

    return {
      hasIframe,
      textFormatterRef
    }
  }
})
</script>

<style lang="scss">
@import '@/assets/styles/_typography.scss';

// DEFAULT
.text-formatter {
    white-space: normal;
    word-break: break-word;
    line-height: 1.5;

    >*:not(:only-child):not(:last-child) {
        margin-bottom: measure(full);
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-top: measure(half);
    }

    >*:first-child {
        margin-top: 0 !important;
    }

    h1 {
        @extend .h1-bold;
    }

    h2 {
        @extend .h2-bold;
    }

    h3 {
        @extend .h3-bold;
    }

    h4 {
        @extend .h3-bold;
    }

    h5 {
        @extend .h3-bold;
    }

    h6 {
        @extend .h3-bold;
    }

    img {
        height: auto;
    }

    a {
        display: inline;
        color: color(brand-blue-2);
        text-decoration: underline;
    }

    strong {
        font-weight: 700;
    }

    em {
        font-style: italic;
    }

    ol,
    ul {
        list-style-position: inside;
        line-height: 2;
    }
}

</style>
